import './App.css';
import {
    Box,
    CircularProgress, Fade,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import {StyledTableRow} from "./TableUtils";
import {userFirstLastName} from "./StringUtils";
import {useEffect, useState} from "react";
import {TransitionGroup} from "react-transition-group";

function PersonsTable({data = [], perpage = 20, loading = false}) {

    const [page, setPage] = useState(0);
    const totalPages = data.length / perpage;

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (page < (totalPages - 1)) {
                setPage(s => s + 1)
            } else {
                setPage(0)
            }
        }, 10000)
        return () => {
            clearInterval(intervalId);
        };
    }, [page, totalPages])

    return (<TableContainer component={Paper}>
            <TransitionGroup>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{fontSize: 18, fontWeight: 'bold'}}>Nome</TableCell>
                            <TableCell sx={{fontSize: 18, fontWeight: 'bold'}}>Time</TableCell>
                            <TableCell sx={{fontSize: 18, fontWeight: 'bold', textAlign: 'center', color: 'blue'}}>Em
                                Andamento</TableCell>
                            <TableCell sx={{fontSize: 18, fontWeight: 'bold', textAlign: 'center'}}>Pendente</TableCell>
                            <TableCell sx={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: 'red'
                            }}>Vencido</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && (perpage > 0
                                ? data.slice((+page * +perpage), +((+page * +perpage) + +perpage))
                                : data
                        ).map((item, index) => (
                            <Fade in={true} style={{transformOrigin: '0 0 0'}} timeout={1000}>
                                <StyledTableRow key={item.analista_id}>
                                    <TableCell
                                        sx={{
                                            fontSize: 18,
                                            fontWeight: 'bold'
                                        }}>{userFirstLastName(item.analista)}</TableCell>
                                    <TableCell sx={{fontSize: 18, fontWeight: 'bold'}}>{item.time}</TableCell>
                                    <TableCell sx={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>{item.total_andamento}</TableCell>
                                    <TableCell sx={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>{item.total_pendente}</TableCell>
                                    <TableCell sx={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>{item.total_vencido}</TableCell>
                                </StyledTableRow>
                            </Fade>
                        ))}
                        {loading && <TableRow>
                            <TableCell colSpan={5} sx={{textAlign: "center"}}>
                                <Box sx={{m: 1}}><CircularProgress size={20}/></Box>
                            </TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TransitionGroup>
        </TableContainer>
    );
}

export default PersonsTable;
